export default "__VITE_ASSET__s_8ew3zJ__"